import { useRouter } from 'next/router';

const usePathname = () => {
  const router = useRouter();
  if (typeof window !== 'undefined' && window?.location?.pathname) return window.location.pathname;

  return router.asPath?.split('?')?.[0];
};

export default usePathname;
